import React, { useContext, useRef } from 'react'
import Image from 'next/image'
import cn from 'classnames'
import { useMarketSelector } from './useMarketSelector'
import { SiteDataContext } from '@/src/components'
import IconNew from '../IconNew'

const MarketSelector = ({ isOpen, onClose }) => {
  const { isTextRtl } = useContext(SiteDataContext)
  const ref = useRef(null)
  const { marketList } = useMarketSelector({ isOpen, onClose, ref })

  return (
    <div
      className={cn('c-market-selector', {
        'c-market-selector__is-open': isOpen,
        'c-market-selector--rtl': isTextRtl
      })}
      ref={ref}
    >
      <button
        type="button"
        onClick={() => onClose()}
        className="c-notification__close"
        aria-label={'close'}
      >
        <IconNew name="tabler-x" size={20} />
      </button>
      <ul>
        {marketList.map((m) => (
          <li key={m.countryIsoCode} className="c-market-selector__option">
            <Image
              className="c-market-selector__option__image"
              priority
              src={m?.svgFlagRound?.url}
              width={24}
              height={24}
              alt={`${m.title} flag`}
            />
            <div className="c-market-selector__option__content">
              <div className="c-market-selector__option__content__language-label">{m.title}</div>
              <div className="c-market-selector__option__content__languages-container">
                {m.languages.map((l) => (
                  <a
                    key={l.slug}
                    href={l.slug}
                    className="c-market-selector__option__content__language"
                  >
                    {l.label}
                  </a>
                ))}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default MarketSelector
